import { render, staticRenderFns } from "./rsv-rapid-test.vue?vue&type=template&id=65a36a59&scoped=true&"
import script from "./rsv-rapid-test.vue?vue&type=script&lang=js&"
export * from "./rsv-rapid-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a36a59",
  null
  
)

export default component.exports